import { FileTextIcon, ZapIcon, BotIcon, MonitorSmartphoneIcon, LayersIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Works with ChatGPT, Claude, Gemini & other compatible AI assistants'
}, {
  icon: MonitorSmartphoneIcon,
  label: 'Designed for desktop and mobile access'
}, {
  icon: LayersIcon,
  label: 'Practical prompts organized into six specialized volumes'
}];
export const stats = [{
  value: '500+',
  label: 'Satisfied Professionals'
}, {
  value: '6+4',
  label: 'Volumes + Bonuses'
}, {
  value: '99%',
  label: 'Success Rate'
}, {
  value: '4.9/5',
  label: '⭐ Customer Rating'
}];
